// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import config from '../../../../share/config';
import session from '../../../../share/session';
import error from '../../../../common/nodejs/errors';

import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import util from '../../../../share/util/utils';

/**
 * 各フェーズ定義
 */
const PHASE = {
  START: 'start',
  CONFIRMATION: 'confirmation',
  EXECUTE: 'execute',
  SUCCESS: 'success',
  OVER_SPEED: 'overSpeed',
  RUDDER_SENSOR_ERROR: 'rudderSensorError',
  LATERAL_SENSOR_ERROR: 'lateralSensorError',
  FRONT_REAR_SENSOR_ERROR: 'frontRearSensorError',
  UNABLE_TO_START: 'unableToStart',
  FAILED: 'failed',
  COMMON_FAILED: 'commonFailed'
};

/**
 * センサ判定フェーズ定義
 */
const SENSOR_CHECK = {
  RUDDER: 'rudder',
  LATERAL: 'lateral',
  FRONT_REAR: 'frontRear'
};

/**
 * 待ち時間定義
 */
const WAIT_TIME = {
  TIME_1000: 1000,
  TIME_5000: 5000,
  TIME_8000: 8000
};

export default {
  name: 'requirement112',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      systemId: '',
      sensorCheck: '',
      timer: null,
      isFirst: true,
      modal_requirement_112: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.COMMON_FAILED:
        case PHASE.OVER_SPEED:
        case PHASE.RUDDER_SENSOR_ERROR:
        case PHASE.LATERAL_SENSOR_ERROR:
        case PHASE.FRONT_REAR_SENSOR_ERROR:
        case PHASE.UNABLE_TO_START:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.START:
        case PHASE.EXECUTE:
        default:
          return 'secondary';
      }
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /**
     * 初期化処理
     */
    init() {
      this.modal_requirement_112 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      // 待機遷移処理
      this.startProcess();
    },

    /**
     * Wizardを閉じる
     */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_112 = false;
    },

    /**
     * 終了処理
     * @param {*} isError エラー遷移の有無
     */
    async exit(isError) {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'exit',
            is_first: this.isFirst
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (isError) {
          if (response) {
            // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
            // エラーコールバックが呼ばれた場合は、null になる。
            switch (response.data.status) {
              case config.STATUS_WSP_COMPLETED:
                // 正常終了
                // Wizardを閉じる
                this.closeWizard();
                break;
              case config.STATUS_WSP_FAILED:
              default:
                // 該当のエラーコードが存在しない場合、汎用エラー
                this.showUnexpectedError();
                break;
            }
          }
        } else {
          // エラー遷移なし：機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /**
     * その他エラー発生時の表示
     */
    showUnexpectedError() {
      this.phase = PHASE.COMMON_FAILED;
    },

    /**
     * 待機遷移処理
     */
    async startProcess() {
      this.phase = PHASE.START;
      // 1000ms経過後、確認画面に遷移
      await util.sleep(WAIT_TIME.TIME_1000);
      this.confirmProcess();
    },

    /**
     * 確認遷移処理
     */
    async confirmProcess() {
      this.phase = PHASE.CONFIRMATION;
      // 8000ms経過後、フェーズの変更がない場合失敗画面へ遷移
      this.timer = setTimeout(async () => await this.failedProcess(WAIT_TIME.TIME_5000), WAIT_TIME.TIME_8000);
    },

    /**
     * 舵角センサ判定遷移処理
     */
    async rudderSensorProcess() {
      clearTimeout(this.timer);
      this.timer = null;
      this.sensorCheck = SENSOR_CHECK.RUDDER;
      // データ読出し処理
      await this.read('read-steering');
    },

    /**
     * 横Gセンサ判定遷移処理
     */
    async lateralSensorProcess() {
      this.sensorCheck = SENSOR_CHECK.LATERAL;
      // データ読出し処理
      await this.read('read-lateral_g');
    },

    /**
     * 前後Gセンサ判定遷移処理
     */
    async frontRearSensorProcess() {
      this.sensorCheck = SENSOR_CHECK.FRONT_REAR;
      // データ読出し&SessionTransition遷移処理
      await this.readSessionTransition();
    },

    /**
     * 実行遷移処理
     */
    async executeProcess() {
      this.phase = PHASE.EXECUTE;
      // ルーチン実行・結果確認処理(VDC中点設定モード)
      await this.execute();
    },

    /**
     * 停止(正常終了)遷移処理
     * @param time - 経過時間
     */
    async successProcess(time) {
      this.phase = PHASE.SUCCESS;
      // 指定時間経過後、終了処理(エラー遷移あり)へ遷移
      await util.sleep(time);
      await this.exit(true);

    },

    /**
     * 車輪速超過遷移処理
     * @param time - 経過時間
     */
    async overSpeedProcess(time) {
      this.phase = PHASE.OVER_SPEED;
      // 指定時間経過後、Wizardを閉じる
      await util.sleep(time);
      this.closeWizard();
    },

    /**
     * 舵角センサ値異常遷移処理
     * @param time - 経過時間
     */
    async rudderSensorErrProcess(time) {
      this.phase = PHASE.RUDDER_SENSOR_ERROR;
      // 指定時間経過後、失敗処理へ遷移
      await util.sleep(time);
      await this.failedProcess(time);
    },

    /**
     * 横Gセンサ値異常遷移処理
     * @param time - 経過時間
     */
    async lateralSensorErrProcess(time) {
      this.phase = PHASE.LATERAL_SENSOR_ERROR;
      // 指定時間経過後、失敗処理へ遷移
      await util.sleep(time);
      await this.failedProcess(time);
    },

    /**
     * 前後Gセンサ値異常遷移処理
     * @param time - 経過時間
     */
    async frontRearErrProcess(time) {
      this.phase = PHASE.FRONT_REAR_SENSOR_ERROR;
      // 指定時間経過後、失敗処理へ遷移
      await util.sleep(time);
      await this.failedProcess(time);
    },

    /**
     * 開始不可遷移処理
     * @param time - 経過時間
     */
    async unableToStartProcess(time) {
      this.phase = PHASE.UNABLE_TO_START;
      // 指定時間経過後、終了処理(エラー遷移あり)へ遷移
      await util.sleep(time);
      await this.exit(true);
    },

    /**
     * 失敗遷移処理
     * @param time - 経過時間
     */
    async failedProcess(time) {
      this.phase = PHASE.FAILED;
      this.isLoading = false;
      // 指定時間経過後、終了処理へ遷移
      await util.sleep(time);
      // OK押下後は終了処理(エラー遷移あり)を呼び出す
      await this.exit(true);
    },

    /**
     * データ読出し処理(要求&取得)
     * @param type - リクエストタイプ
     */
    async read(type) {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: type,
            is_first: this.isFirst
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              switch (this.sensorCheck) {
                case SENSOR_CHECK.RUDDER:
                  // 舵角センサ判定時の処理
                  // 横Gセンサ判定に遷移
                  await this.lateralSensorProcess();
                  break;
                case SENSOR_CHECK.LATERAL:
                  // 横Gセンサ判定時の処理
                  // 前後Gセンサ判定に遷移
                  await this.frontRearSensorProcess();
                  break;
                default:
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了
              switch (parseInt(response.data.async_code)) {
                case error.WSP_112_SENSOR_VALUE_ERROR:
                  // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                  /* eslint-disable max-depth */
                  switch (this.sensorCheck) {
                    case SENSOR_CHECK.RUDDER:
                      // 舵角センサ値異常に遷移
                      this.rudderSensorErrProcess(response.data.user_data.wait_time);
                      break;
                    case SENSOR_CHECK.LATERAL:
                      // 横Gセンサ値異常に遷移
                      this.lateralSensorErrProcess(response.data.user_data.wait_time);
                      break;
                    default:
                      break;
                  }
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、汎用エラー
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /**
     * Session遷移を伴うデータ読出し処理(要求&取得)
     */
    async readSessionTransition() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read_session'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // セキュリティアクセス判定
              await this.secAccess();
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了
              switch (parseInt(response.data.async_code)) {
                case error.WSP_EXCESSIVE_WHEEL_SPEED_ERROR:
                  // 車輪速超過に遷移
                  this.overSpeedProcess(response.data.user_data.wait_time);
                  break;
                case error.WSP_112_SENSOR_VALUE_ERROR:
                  // 前後Gセンサ値異常に遷移
                  this.frontRearErrProcess(response.data.user_data.wait_time);
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、汎用エラー
                  // 共通エラーに遷移
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** セキュリティアクセス判定 */
    async secAccess() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'sec_access'
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 実行/実行監視に遷移
              await this.executeProcess();
              break;
            case config.STATUS_WSP_FAILED:
              // 共通エラーに遷移
              this.showUnexpectedError();
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * ルーチン実行・結果確認処理(VDCセンサ中点設定モード)(要求&取得)
     */
    async execute() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 停止(正常終了)に遷移
              this.successProcess(response.data.user_data.wait_time);
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了
              switch (parseInt(response.data.async_code)) {
                case error.WSP_112_EXECUTE_FAILED_ERROR:
                  // 開始不可に遷移
                  this.unableToStartProcess(response.data.user_data.wait_time);
                  break;
                default:
                  // 失敗に遷移
                  await this.failedProcess(response.data.user_data.wait_time);
                  break;
              }
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result バリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },
  },

  /**
   * DOM作成後実行処理
   */
  async mounted() {
    // 初期化
    this.init();
  },
};